<template>
  <div class="side-bar">
    <aside class="menu">
      <p class="menu-label">
        Admin
      </p>
      <ul class="menu-list">
        <li><router-link to="dashboard" :class="{ 'is-active': $route.name === 'dashboard' }">Dashboard</router-link></li>
        <li><router-link to="users" :class="{ 'is-active': $route.name === 'users' }">Users</router-link></li>
        <li><router-link to="projects" :class="{ 'is-active': $route.name === 'projects' }">Projects</router-link></li>
      </ul>
      <p class="menu-label">
        Debug
      </p>
      <ul class="menu-list">
        <li><router-link to="blogs" :class="{ 'is-active': $route.name === 'blogs' }">Blogs</router-link></li>
        <li><router-link to="components" :class="{ 'is-active': $route.name === 'components' }">Components</router-link></li>
      </ul>
    </aside>
  </div>
</template>

<script>
  // import _ from 'lodash'
  export default {
    name: 'sidebar',
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.activeLink = to.path
      })
    },
    beforeRouteUpdate (to, from, next) {
      this.activeLink = to.path
      next()
    },
    // mounted () {
    //   console.log('Component mounted.')
    //   let match = _.chain(this.$route.matched).sortBy(n => n.path.length).last().value()
    //   this.activeLink = match.path
    // },
    data () {
      return {
        activeLink: null
      }
    }
  }
</script>

<style>
.side-bar {
  padding: 20px;
  padding-left: 30px;
  padding-top: 70px;
  padding-bottom: 50px;
}

.menu-list a {
  border-radius: 2px;
}

</style>



// WEBPACK FOOTER //
// SideBar.vue?000e624c